import { Client, ClientEventRow } from '../../model/types';
import { concatArray } from '@shared/lib';

export const mapClientsEventToTableRows = (clients: Client[]): ClientEventRow[] =>
  clients.map((client) => {
    const managerFio = concatArray([client.manager?.lastName, client.manager?.firstName, client.manager?.surname]);
    const invitingManager = client.ticket.organizerName || managerFio;

    return {
      clientInfo: {
        FIO: concatArray([client.lastName, client.firstName, client.surname]),
        age: client.age,
        photo: client.photoUrl,
        countChildren: client.countChildren,
        maritalStatus: client.maritalStatus,
        mobileComment: client.ticket.mobileComment,
      },
      projects: client.projects,
      notes: client.notes || '',
      comment: client.ticket?.comment || '',
      invitation: (client.ticket.sminexClubInvitation || '').toUpperCase(),
      reconfirmationStatus: (client.ticket.sminexClubReconfirmationStatus || '').toUpperCase(),
      checked: client.ticket.checked,
      brokers: client.brokerName ? [client.brokerName] : [],
      salesManager: managerFio,
      invitingManager,
      calls: client.doNotCall ?? null,
      review: client.ticket?.review || '',
      actions: '',
      additionalGuest: client.ticket?.sminexClubAdditional,
      ticketId: client.ticket.id,
      id: client.rowKey ?? client.id,
      isSpecial: client.isSpecial,
    };
  });
